'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamOverlay = require('./CamOverlay');

var _CamOverlay2 = _interopRequireDefault(_CamOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamOverlay2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamOverlay/index.js
// module id = 89
// module chunks = 11